import { takeEvery, put, call } from "redux-saga/effects";
import { showError } from "../../utils/helper";
import { SUBMIT_CSAT, HANDLE_CSAT } from "../action/types";
import {
  submitCsatSuccess,
  submitCsatFailure,
  handleCsatSuccess,
  handleCsatFailure,
} from "../action/csatAction";
import USERS from "../../utils/api/users";
import { toast } from "react-toastify";
import POSITION from "../../utils/api/candidate";

function* submitCsatRequest(action) {
  const { payload, onSuccess, onFailure } = action.payload || {};
  const { interviewId, answers: apiPayload, productId } = payload || {};
  const submitBody = { interviewId, answers: apiPayload, productId };
  try {
    const res = yield POSITION.post(
      "incscreen/interviews/csat/submitCsat",
      submitBody,
    );
    if (res.status === 200 || res.status === 201) {
      const { message } = res.data.result || {};
      toast.success(message || "Feedback submitted successfully");
      yield put(submitCsatSuccess());
      if (onSuccess) yield call(onSuccess);
    } else {
      yield put(submitCsatFailure());
      if (onFailure) yield call(onFailure);
    }
  } catch (e) {
    yield put(submitCsatFailure());
    yield call(showError, e);
    if (onFailure) yield call(onFailure);
  }
}

function* handleCsatRequest(action) {
  const {
    action: csatAction,
    interviewId,
    productId,
    onSuccess,
    onFailure,
  } = action.payload || {};

  try {
    const handlePayload = {
      action: csatAction,
      ...(interviewId && { interviewId }),
      ...(productId && { productId }),
    };
    const res = yield USERS.post("users/csat/handleCsat", handlePayload);
    const result = res.data?.result;
    if (res.status === 200 || res.status === 201) {
      yield put(handleCsatSuccess(result || {}));
      if (onSuccess) yield call(onSuccess);
    } else {
      yield put(handleCsatFailure());
      if (onFailure) yield call(onFailure);
    }
  } catch (e) {
    yield put(handleCsatFailure());
    yield call(showError, e);
    if (onFailure) yield call(onFailure);
  }
}

export default function* csatSaga() {
  yield takeEvery(SUBMIT_CSAT, submitCsatRequest);
  yield takeEvery(HANDLE_CSAT, handleCsatRequest);
}
